import type { OpportunityStatus, SingleOpportunity } from '@ps/web-sports-api-types';

import { type Entity, sportsSelection } from '../entities';
import { buttonClick } from '../events';
import type { TrackingContextValue } from '../providers/TrackingContext';
import { GAEvent, getEntities } from '../utils';

import { getIsAvailableOpportunity } from './getIsOpportunity';
import getRunnerStatus from './getRunnerStatus';

export type BetslipClearedProps = SingleOpportunity[];
export const betslipCleared = (
  context: TrackingContextValue,
  singleOpportunities: BetslipClearedProps
) => {
  const entities: Entity[] = singleOpportunities.map((single) => {
    const selectionOdds = getIsAvailableOpportunity(single)
      ? single.winRunnerOdds?.decimalDisplayOdds?.decimalOdds
      : undefined;

    const selectionEntity = sportsSelection({
      selectionId: single.runnerId.selectionId,
      selectionOdds,
      selectionStatus: getRunnerStatus(single.status as OpportunityStatus),
      isStartingPrice: !selectionOdds
    });

    return selectionEntity;
  });

  const clearBetSlipContext = {
    category: context.category,
    widget: context.widget,
    entities: [...getEntities(context), ...entities]
  };

  GAEvent({ action: 'Clear Bet Slip' }, clearBetSlipContext);
  buttonClick({ buttonName: 'Clear Bet Slip' }, clearBetSlipContext);
};
